import { AppContext } from "../../context/context";
import { decryptData, isTokenValid } from '../../utils/utils';
import { Dispatch, useContext, useEffect, useState } from "react";
import { StatusCodes } from "http-status-codes";
import apis from "../../apis/api";
import { ls } from "../../localStorage";
import { useLocation, useNavigate } from "react-router-dom";
import AdaptivePracticeForStudents from "./AdaptivePracticeForStudents";
import AdaptivePracticeForTeachers from "./AdaptivePracticeForTeachers";
import { useSelector } from "react-redux";
import { IReducer, IUserReducer } from "../../interface/interface";
import jwt_decode from "jwt-decode";
import { useDispatch } from "react-redux";
import { userAction } from "../../reduxStore";
import { Theme } from './theme';
import { Loader } from './Loader';

interface IAPcurrentUser {
    id: string,
    classroom_id?: string,
    isB2C: boolean,
    curriculum_id?: string,
    unit_plan_id?: string,
    grade: number,
    role: string,
    dbToken: string,
    total_lo: number,
    token: string
}

export function AdaptivePractice(props: any) {
    const navigate = useNavigate();
    const dispatch: Dispatch<any> = useDispatch();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const QUERY: { currentUser: IAPcurrentUser } | any = queryParams.get("query");
    const skillId: string | any = queryParams.get("skillId");
    const lang: string | any = queryParams.get("lang");
    const loginToken: string | any = queryParams.get("token");
    const platform: string | any = queryParams.get("platform");
    const state: any = useContext(AppContext);
    const [currentUser, setCurrentUser]: IAPcurrentUser | any = useState({});
    // Theme chosen in student/teacher web settings, carried in the encrypted payload.
    const [theme, setTheme] = useState<Theme | undefined>(undefined);
    const [isLoader, setIsLoader] = useState(false);

    const userReducer: IUserReducer = useSelector((state: IReducer) => state.userReducer);

    useEffect(() => {
        verifyAndSetData();
    }, [])

    const verifyAndSetData = async () => {
        try {
            // console.log(queryParams);

            let currentUser: IAPcurrentUser | any = {};
            setIsLoader(true);
            if (QUERY) {
                // console.log(QUERY);
                let query: { currentUser: IAPcurrentUser, theme?: Theme } = decryptData(QUERY);
                setTheme(query.theme);
                currentUser = query.currentUser;

                // clear redux if user not match with redux user
                if (userReducer.currentUser.id && currentUser.id.toString() !== userReducer.currentUser.id.toString())
                    dispatch(userAction.setInitialState());

                dispatch(userAction.setCurrentUser(currentUser));
                // console.log(currentUser);
            }
            else {
                // call api to get token based on the login token
                let decode_token: { userId: string } = jwt_decode(loginToken);
                // console.log(decode_token)

                if (userReducer.currentUser.id &&
                    decode_token.userId.toString() === userReducer.currentUser.id.toString()) {
                    currentUser = userReducer.currentUser;
                    let currentToken = ls.getToken();
                    if (!isTokenValid(currentToken)) {
                        let res = await apis._refreshToken();
                        if (res.status === StatusCodes.OK)
                            currentToken = res.data.token
                    }
                    currentUser.token = currentToken;
                }
                else {
                    dispatch(userAction.setInitialState());
                    const init = await apis._initializeSession(loginToken);
                    console.log(init)
                    if (init.status === StatusCodes.OK) {
                        currentUser = init.data.collection
                        ls.setToken(currentUser.token);
                        ls.setDBToken(currentUser.dbToken);

                        dispatch(userAction.setCurrentUser(currentUser));
                    }
                }
            }

            // console.log(currentUser);
            // console.log(isTokenValid(currentUser.token));
            if (await ls.isValid(currentUser) &&
                await isTokenValid(currentUser.token)) {
                // console.log("setLS")
                ls.setToken(currentUser.token);
                ls.setDBToken(currentUser.dbToken);
                setCurrentUser(currentUser);
            }
            else {
                console.log("error while setting local storage");
                state.messageForParent('close');
                navigate('/pageNotFound');
            }
            setIsLoader(false);
        } catch (error) {
            console.log(error);
            state.messageForParent('close');
            navigate('/pageNotFound');
        }
    }

    return (<>
        {(isLoader) && (
            <Loader />
        )}
        {(currentUser.role === 'student' && skillId !== "" && lang !== "") && (
            <AdaptivePracticeForStudents {...props} currentUser={currentUser} skillId={skillId} lang={lang} theme={theme} />
        )}
        {(currentUser.role === 'teacher' && skillId !== "" && lang !== "") && (
            <AdaptivePracticeForTeachers {...props} currentUser={currentUser} skillId={skillId} lang={lang} platform={platform} theme={theme} />
        )}
    </>)
}